import type { PaymentMethodType } from '../../../../../services/customer/types';
import type { FormattedPaymentMethod } from '../types';

export default function isManufacturerCardCategoriesEmpty(
  formattedPaymentMethod: FormattedPaymentMethod<PaymentMethodType>,
) {
  return (
    formattedPaymentMethod.type === 'CARD' &&
    (!formattedPaymentMethod.cardCategories || formattedPaymentMethod.cardCategories.length === 0) &&
    formattedPaymentMethod.isManufacturerCard
  );
}
